import { createListFile } from "./VideoDescription";

export const mediaControl = (video) => {
  const ctrBtnDownload = video?.downloadable && video?.url?.length > 0;
  const ctrBtnAttachment = video?.attachments && video?.attachments?.length > 0;
  const btnDownload = $(`.d-download`);
  const btnAttachment = $(`.d-attachment`);
  if (!ctrBtnDownload) {
    btnDownload.addClass("d-disable");
  } else {
    if (video?.url && video?.url?.length > 0) {
      btnDownload.attr("href", video.url);
    }
    btnDownload.removeClass("d-disable");
  }
  if (!ctrBtnAttachment) {
    btnAttachment.addClass("d-disable");
  } else {
    btnAttachment.removeClass("d-disable");
    $('[data-toggle="popover"]').popover({
      placement: "top",
      trigger: "focus",
    });
    btnAttachment.attr("data-content", createListFile(video.attachments));
    btnAttachment.next(".popover").addClass("popover-danger");
  }
};
